export const SCROLL_WIDTH_OFFSET = 5;
export const SCROLL_BAR_LINE_ID = 'scrollbar-line';
export const SCROLL_BAR_CONTAINER_ID = 'scrollbar-container';
export const SCROLL_KEY_STEP = 40;
export const SCROLL_ARIA_VALUE_MIN = 0;
export const SCROLL_ARIA_VALUE_MAX = 100;
/** Set on `.qmb-ui-table` while pagination is pinned to the viewport bottom. */
export const TABLE_PAGINATION_PIN_HEIGHT_VAR = '--qmb-table-pagination-pin-height';
/** Bubbles from `.qmb-ui-table` after the pin offset changes so the thumb can sit above the pager. */
export const TABLE_PAGINATION_PIN_EVENT = 'qmb-table-pagination-pin';
